import type { EvolutionAttachedPrintable } from './evolutionWorkflowTypes';

/** Receita Memed é documento oficial externo — não editamos o conteúdo clínico aqui. */
export function canEditEvolutionPrintable(p: EvolutionAttachedPrintable): boolean {
  return p.linkedDocumentOrigin !== 'memed';
}

export function evolutionPrintableEditBlockedReason(p: EvolutionAttachedPrintable): string {
  if (p.linkedDocumentOrigin === 'memed') {
    return 'Receita digital Memed: edite ou cancele na plataforma Memed.';
  }
  return '';
}
